import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { languages } from '../../config/languages';
import { MatDialog } from '@angular/material/dialog';
import { RegisterRequest } from '../../models/register.model';
import { Roles } from '../../models';
import { SubSink } from 'subsink';
import { SuccessDialogComponent } from '../../components/success-dialog/success-dialog.component';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'mmg-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {
  logoSrc: string = '';
  title: string = '';
  form: FormGroup;
  invalid = false;

  languages = languages.map(lang => ({
    value: lang.code,
    viewValue: lang.name
  }));

  private readonly subs = new SubSink();

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private dialog: MatDialog
  ) {
    this.logoSrc = environment.logoSrc;
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      name: ['', [Validators.required]],
      language: ['en', [Validators.required]]
    });
  }

  get username(): AbstractControl {
    return this.form.get('username')!;
  }

  get email(): AbstractControl {
    return this.form.get('email')!;
  }

  get name(): AbstractControl {
    return this.form.get('name')!;
  }

  get language(): AbstractControl {
    return this.form.get('language')!;
  }

  ngOnInit(): void {
    this.subs.sink = this.route.data
      .subscribe(data => this.title = data['title']);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  submit(): void {
    if (this.form.valid) {
      const formData: RegisterRequest = {
        username: this.username.value.toLowerCase(),
        email: this.email.value.toLowerCase(),
        name: this.name.value,
        language: this.language.value,
        roles: [Roles.Member]
      };
      
      this.subs.sink = this.userService.register(formData)
        .subscribe({
          next: () => {
            // Show success dialog
            const dialogRef = this.dialog.open(SuccessDialogComponent, {
              width: '400px',
              disableClose: true,
              data: { email: formData.email }
            });

            // After dialog is closed, redirect to login
            dialogRef.afterClosed().subscribe(() => {
              this.router.navigate(['/login']);
            });
          },
          error: () => {
            this.invalid = true;
          }
        });
    }
  }
} 